import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Workshops from '../components/Workshops';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const WorkshopsPage = () => {
  const [activeSection, setActiveSection] = useState('workshops');

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'home' || sectionId === 'about' || sectionId === 'services') {
      window.location.href = '/';
      return;
    }
    
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 64;
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['workshops', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-900">
      <Header activeSection={activeSection} onSectionChange={scrollToSection} />
      <main className="pt-16">
        <Workshops />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default WorkshopsPage;
